module.exports = __webpack_public_path__ + "img/building-blue.6b227b73.jpeg";